var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g2, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _g3, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncomeDoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 137,
    viewBox: "0 0 206 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_265_421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.23999 41.5199C3.23999 40.6363 3.95633 39.9199 4.83999 39.9199H26.7223C27.1788 39.9199 27.6136 40.115 27.9173 40.4559L40.0349 54.065C40.2958 54.358 40.44 54.7367 40.44 55.129V88.3199C40.44 89.2036 39.7236 89.9199 38.84 89.9199H4.83999C3.95634 89.9199 3.23999 89.2036 3.23999 88.3199V41.5199Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.92498 91.2801H39.155C40.503 91.2801 41.6 90.1831 41.6 88.8351V54.6051C41.6 54.5774 41.5869 54.5546 41.5853 54.5285C41.5821 54.491 41.5723 54.4584 41.5641 54.4226C41.5385 54.3093 41.4885 54.2031 41.4174 54.1112C41.406 54.0966 41.4076 54.0786 41.3962 54.064L28.3562 39.394C28.3513 39.3891 28.3448 39.3891 28.3399 39.3842C28.2405 39.2802 28.1149 39.2048 27.9764 39.1658C27.9455 39.156 27.9178 39.1527 27.8852 39.1478C27.8379 39.1397 27.7939 39.1201 27.745 39.1201H4.92498C3.57697 39.1201 2.47998 40.2171 2.47998 41.5651V88.8351C2.47998 90.1831 3.57697 91.2801 4.92498 91.2801ZM28.56 42.0786L38.9708 53.7901H29.375C29.0164 53.7901 28.56 53.1055 28.56 52.5676V42.0786ZM4.10998 41.5651C4.10998 41.349 4.19585 41.1417 4.34869 40.9888C4.50153 40.836 4.70883 40.7501 4.92498 40.7501H26.93V52.5676C26.93 53.8863 27.9976 55.4201 29.375 55.4201H39.97V88.8351C39.97 89.0513 39.8841 89.2586 39.7313 89.4114C39.5784 89.5642 39.3711 89.6501 39.155 89.6501H4.92498C4.46858 89.6501 4.10998 89.2915 4.10998 88.8351V41.5651Z",
    fill: "#514C9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9709 53.7902L28.5601 42.0786V52.5677C28.5601 53.1056 29.0165 53.7902 29.3751 53.7902H38.9709Z",
    fill: "#514C9F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9709 53.7902L28.5601 42.0786V52.5677C28.5601 53.1056 29.0165 53.7902 29.3751 53.7902H38.9709Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9709 53.7902L28.5601 42.0786V52.5677C28.5601 53.1056 29.0165 53.7902 29.3751 53.7902H38.9709Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.28 49.2002H8.71997H9.96361C10.4034 49.2002 10.8251 49.3736 11.1361 49.6822C11.4471 49.9908 11.6218 50.4094 11.6218 50.8459C11.6218 51.2824 11.4471 51.701 11.1361 52.0096C10.8251 52.3182 10.4034 52.4916 9.96361 52.4916H8.71997L11.2072 54.9602M8.71997 50.8459H13.28",
    stroke: "#514C9F",
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.28 49.2002H8.71997H9.96361C10.4034 49.2002 10.8251 49.3736 11.1361 49.6822C11.4471 49.9908 11.6218 50.4094 11.6218 50.8459C11.6218 51.2824 11.4471 51.701 11.1361 52.0096C10.8251 52.3182 10.4034 52.4916 9.96361 52.4916H8.71997L11.2072 54.9602M8.71997 50.8459H13.28",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.28 49.2002H8.71997H9.96361C10.4034 49.2002 10.8251 49.3736 11.1361 49.6822C11.4471 49.9908 11.6218 50.4094 11.6218 50.8459C11.6218 51.2824 11.4471 51.701 11.1361 52.0096C10.8251 52.3182 10.4034 52.4916 9.96361 52.4916H8.71997L11.2072 54.9602M8.71997 50.8459H13.28",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.28 77.04H8.71997H9.96361C10.4034 77.04 10.8251 77.2134 11.1361 77.5221C11.4471 77.8307 11.6218 78.2493 11.6218 78.6858C11.6218 79.1222 11.4471 79.5408 11.1361 79.8494C10.8251 80.1581 10.4034 80.3315 9.96361 80.3315H8.71997L11.2072 82.8M8.71997 78.6858H13.28",
    stroke: "#514C9F",
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.28 77.04H8.71997H9.96361C10.4034 77.04 10.8251 77.2134 11.1361 77.5221C11.4471 77.8307 11.6218 78.2493 11.6218 78.6858C11.6218 79.1222 11.4471 79.5408 11.1361 79.8494C10.8251 80.1581 10.4034 80.3315 9.96361 80.3315H8.71997L11.2072 82.8M8.71997 78.6858H13.28",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.28 77.04H8.71997H9.96361C10.4034 77.04 10.8251 77.2134 11.1361 77.5221C11.4471 77.8307 11.6218 78.2493 11.6218 78.6858C11.6218 79.1222 11.4471 79.5408 11.1361 79.8494C10.8251 80.1581 10.4034 80.3315 9.96361 80.3315H8.71997L11.2072 82.8M8.71997 78.6858H13.28",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.28 63.3604H8.71997H9.96361C10.4034 63.3604 10.8251 63.5337 11.1361 63.8424C11.4471 64.151 11.6218 64.5696 11.6218 65.0061C11.6218 65.4425 11.4471 65.8611 11.1361 66.1698C10.8251 66.4784 10.4034 66.6518 9.96361 66.6518H8.71997L11.2072 69.1204M8.71997 65.0061H13.28",
    stroke: "#514C9F",
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.28 63.3604H8.71997H9.96361C10.4034 63.3604 10.8251 63.5337 11.1361 63.8424C11.4471 64.151 11.6218 64.5696 11.6218 65.0061C11.6218 65.4425 11.4471 65.8611 11.1361 66.1698C10.8251 66.4784 10.4034 66.6518 9.96361 66.6518H8.71997L11.2072 69.1204M8.71997 65.0061H13.28",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.28 63.3604H8.71997H9.96361C10.4034 63.3604 10.8251 63.5337 11.1361 63.8424C11.4471 64.151 11.6218 64.5696 11.6218 65.0061C11.6218 65.4425 11.4471 65.8611 11.1361 66.1698C10.8251 66.4784 10.4034 66.6518 9.96361 66.6518H8.71997L11.2072 69.1204M8.71997 65.0061H13.28",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3005 54.7172C16.113 54.9047 16.113 55.2086 16.3005 55.3961C16.4879 55.5835 16.7919 55.5835 16.9793 55.3961L16.3005 54.7172ZM22.5927 49.5838C22.5927 49.3187 22.3778 49.1038 22.1127 49.1038H17.7927C17.5276 49.1038 17.3127 49.3187 17.3127 49.5838C17.3127 49.8489 17.5276 50.0638 17.7927 50.0638H21.6327V53.9038C21.6327 54.1689 21.8476 54.3838 22.1127 54.3838C22.3778 54.3838 22.5927 54.1689 22.5927 53.9038V49.5838ZM16.9793 55.3961L22.4521 49.9232L21.7733 49.2444L16.3005 54.7172L16.9793 55.3961Z",
    fill: "#ECEBFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3005 82.5571C16.113 82.7445 16.113 83.0484 16.3005 83.2359C16.4879 83.4233 16.7919 83.4233 16.9793 83.2359L16.3005 82.5571ZM22.5927 77.4236C22.5927 77.1585 22.3778 76.9436 22.1127 76.9436H17.7927C17.5276 76.9436 17.3127 77.1585 17.3127 77.4236C17.3127 77.6887 17.5276 77.9036 17.7927 77.9036H21.6327V81.7436C21.6327 82.0087 21.8476 82.2236 22.1127 82.2236C22.3778 82.2236 22.5927 82.0087 22.5927 81.7436V77.4236ZM16.9793 83.2359L22.4521 77.7631L21.7733 77.0842L16.3005 82.5571L16.9793 83.2359Z",
    fill: "#ECEBFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4993 64.0831C22.6868 63.8956 22.6868 63.5917 22.4993 63.4042C22.3119 63.2168 22.008 63.2168 21.8205 63.4042L22.4993 64.0831ZM16.2071 69.2165C16.2071 69.4816 16.422 69.6965 16.6871 69.6965H21.0071C21.2722 69.6965 21.4871 69.4816 21.4871 69.2165C21.4871 68.9514 21.2722 68.7365 21.0071 68.7365H17.1671V64.8965C17.1671 64.6314 16.9522 64.4165 16.6871 64.4165C16.422 64.4165 16.2071 64.6314 16.2071 64.8965V69.2165ZM21.8205 63.4042L16.3477 68.8771L17.0265 69.5559L22.4993 64.0831L21.8205 63.4042Z",
    fill: "#ECEBFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1199 81.8403H36.4399",
    stroke: "#514C9F",
    strokeWidth: 0.96,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1199 68.3999H36.4399",
    stroke: "#514C9F",
    strokeWidth: 0.96,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1199 79.9199H36.4399",
    stroke: "#514C9F",
    strokeWidth: 0.96,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1199 66.48H36.4399",
    stroke: "#514C9F",
    strokeWidth: 0.96,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1199 78H36.4399",
    stroke: "#514C9F",
    strokeWidth: 0.96,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1199 64.5601H36.4399",
    stroke: "#514C9F",
    strokeWidth: 0.96,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_265_421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.5 6C60.5 3.79086 62.2909 2 64.5 2H119.206C120.347 2 121.434 2.48758 122.193 3.34001L152.487 37.3627C153.14 38.0953 153.5 39.0419 153.5 40.0227V123C153.5 125.209 151.709 127 149.5 127H64.5C62.2909 127 60.5 125.209 60.5 123V6Z",
    fill: "white"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7126 130.4H150.288C153.658 130.4 156.4 127.658 156.4 124.287V38.7125C156.4 38.6432 156.368 38.5862 156.363 38.521C156.355 38.4272 156.331 38.3457 156.31 38.2561C156.246 37.973 156.121 37.7073 155.944 37.4778C155.915 37.4411 155.919 37.3963 155.891 37.3596L123.291 0.6846C123.279 0.672375 123.262 0.672375 123.25 0.66015C123.001 0.400207 122.688 0.211652 122.341 0.1141C122.264 0.0896505 122.195 0.0814999 122.113 0.0692749C121.995 0.0488999 121.885 0 121.763 0H64.7126C61.3426 0 58.6001 2.74247 58.6001 6.1125V124.287C58.6001 127.658 61.3426 130.4 64.7126 130.4ZM123.8 7.39613L149.827 36.675H125.838C124.941 36.675 123.8 34.9635 123.8 33.6187V7.39613ZM62.6751 6.1125C62.6751 5.57212 62.8898 5.05388 63.2719 4.67177C63.654 4.28966 64.1722 4.075 64.7126 4.075H119.725V33.6187C119.725 36.9154 122.394 40.75 125.838 40.75H152.325V124.287C152.325 124.828 152.11 125.346 151.728 125.728C151.346 126.11 150.828 126.325 150.288 126.325H64.7126C63.5716 126.325 62.6751 125.428 62.6751 124.287V6.1125Z",
    fill: "#514C9F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M149.827 36.6754L123.8 7.39648V33.6191C123.8 34.9639 124.941 36.6754 125.838 36.6754H149.827Z",
    fill: "#514C9F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M149.827 36.6754L123.8 7.39648V33.6191C123.8 34.9639 124.941 36.6754 125.838 36.6754H149.827Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M149.827 36.6754L123.8 7.39648V33.6191C123.8 34.9639 124.941 36.6754 125.838 36.6754H149.827Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6002 25.2002H74.2002H77.3093C78.4087 25.2002 79.4631 25.6337 80.2406 26.4052C81.018 27.1768 81.4547 28.2233 81.4547 29.3145C81.4547 30.4057 81.018 31.4521 80.2406 32.2237C79.4631 32.9953 78.4087 33.4288 77.3093 33.4288H74.2002L80.4184 39.6002M74.2002 29.3145H85.6002",
    stroke: "#514C9F",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6002 25.2002H74.2002H77.3093C78.4087 25.2002 79.4631 25.6337 80.2406 26.4052C81.018 27.1768 81.4547 28.2233 81.4547 29.3145C81.4547 30.4057 81.018 31.4521 80.2406 32.2237C79.4631 32.9953 78.4087 33.4288 77.3093 33.4288H74.2002L80.4184 39.6002M74.2002 29.3145H85.6002",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6002 25.2002H74.2002H77.3093C78.4087 25.2002 79.4631 25.6337 80.2406 26.4052C81.018 27.1768 81.4547 28.2233 81.4547 29.3145C81.4547 30.4057 81.018 31.4521 80.2406 32.2237C79.4631 32.9953 78.4087 33.4288 77.3093 33.4288H74.2002L80.4184 39.6002M74.2002 29.3145H85.6002",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6002 94.7998H74.2002H77.3093C78.4087 94.7998 79.4631 95.2333 80.2406 96.0049C81.018 96.7764 81.4547 97.8229 81.4547 98.9141C81.4547 100.005 81.018 101.052 80.2406 101.823C79.4631 102.595 78.4087 103.028 77.3093 103.028H74.2002L80.4184 109.2M74.2002 98.9141H85.6002",
    stroke: "#514C9F",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6002 94.7998H74.2002H77.3093C78.4087 94.7998 79.4631 95.2333 80.2406 96.0049C81.018 96.7764 81.4547 97.8229 81.4547 98.9141C81.4547 100.005 81.018 101.052 80.2406 101.823C79.4631 102.595 78.4087 103.028 77.3093 103.028H74.2002L80.4184 109.2M74.2002 98.9141H85.6002",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6002 94.7998H74.2002H77.3093C78.4087 94.7998 79.4631 95.2333 80.2406 96.0049C81.018 96.7764 81.4547 97.8229 81.4547 98.9141C81.4547 100.005 81.018 101.052 80.2406 101.823C79.4631 102.595 78.4087 103.028 77.3093 103.028H74.2002L80.4184 109.2M74.2002 98.9141H85.6002",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6002 60.6001H74.2002H77.3093C78.4087 60.6001 79.4631 61.0336 80.2406 61.8051C81.018 62.5767 81.4547 63.6232 81.4547 64.7144C81.4547 65.8056 81.018 66.852 80.2406 67.6236C79.4631 68.3952 78.4087 68.8287 77.3093 68.8287H74.2002L80.4184 75.0001M74.2002 64.7144H85.6002",
    stroke: "#514C9F",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6002 60.6001H74.2002H77.3093C78.4087 60.6001 79.4631 61.0336 80.2406 61.8051C81.018 62.5767 81.4547 63.6232 81.4547 64.7144C81.4547 65.8056 81.018 66.852 80.2406 67.6236C79.4631 68.3952 78.4087 68.8287 77.3093 68.8287H74.2002L80.4184 75.0001M74.2002 64.7144H85.6002",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6002 60.6001H74.2002H77.3093C78.4087 60.6001 79.4631 61.0336 80.2406 61.8051C81.018 62.5767 81.4547 63.6232 81.4547 64.7144C81.4547 65.8056 81.018 66.852 80.2406 67.6236C79.4631 68.3952 78.4087 68.8287 77.3093 68.8287H74.2002L80.4184 75.0001M74.2002 64.7144H85.6002",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1515 38.9928C92.6828 39.4614 92.6828 40.2212 93.1515 40.6898C93.6201 41.1585 94.3799 41.1585 94.8485 40.6898L93.1515 38.9928ZM108.882 26.1592C108.882 25.4965 108.345 24.9592 107.682 24.9592H96.8821C96.2194 24.9592 95.6821 25.4965 95.6821 26.1592C95.6821 26.8219 96.2194 27.3592 96.8821 27.3592L106.482 27.3592V36.9592C106.482 37.6219 107.019 38.1592 107.682 38.1592C108.345 38.1592 108.882 37.6219 108.882 36.9592V26.1592ZM94.8485 40.6898L108.531 27.0077L106.834 25.3107L93.1515 38.9928L94.8485 40.6898Z",
    fill: "#ECEBFF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1515 108.592C92.6828 109.061 92.6828 109.821 93.1515 110.289C93.6201 110.758 94.3799 110.758 94.8485 110.289L93.1515 108.592ZM108.882 95.7588C108.882 95.0961 108.345 94.5588 107.682 94.5588H96.8821C96.2194 94.5588 95.6821 95.0961 95.6821 95.7588C95.6821 96.4216 96.2194 96.9588 96.8821 96.9588H106.482V106.559C106.482 107.222 107.019 107.759 107.682 107.759C108.345 107.759 108.882 107.222 108.882 106.559V95.7588ZM94.8485 110.289L108.531 96.6073L106.834 94.9103L93.1515 108.592L94.8485 110.289Z",
    fill: "#ECEBFF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M108.649 62.4076C109.117 61.939 109.117 61.1792 108.649 60.7106C108.18 60.2419 107.42 60.2419 106.952 60.7106L108.649 62.4076ZM92.9179 75.2412C92.9179 75.9039 93.4552 76.4412 94.1179 76.4412H104.918C105.581 76.4412 106.118 75.9039 106.118 75.2412C106.118 74.5784 105.581 74.0412 104.918 74.0412H95.3179V64.4412C95.3179 63.7784 94.7807 63.2412 94.1179 63.2412C93.4552 63.2412 92.9179 63.7784 92.9179 64.4412V75.2412ZM106.952 60.7106L93.2694 74.3927L94.9665 76.0897L108.649 62.4076L106.952 60.7106Z",
    fill: "#ECEBFF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M117.7 106.8H143.5",
    stroke: "#514C9F",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M117.7 73.2002H143.5",
    stroke: "#514C9F",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M117.7 102H143.5",
    stroke: "#514C9F",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M117.7 68.3999H143.5",
    stroke: "#514C9F",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M117.7 97.2002H143.5",
    stroke: "#514C9F",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M117.7 63.6001H143.5",
    stroke: "#514C9F",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_265_421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.16 41.5199C167.16 40.6363 167.876 39.9199 168.76 39.9199H190.642C191.099 39.9199 191.534 40.115 191.837 40.4559L203.955 54.065C204.216 54.358 204.36 54.7367 204.36 55.129V88.3199C204.36 89.2036 203.644 89.9199 202.76 89.9199H168.76C167.876 89.9199 167.16 89.2036 167.16 88.3199V41.5199Z",
    fill: "white"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M168.845 91.2801H203.075C204.423 91.2801 205.52 90.1831 205.52 88.8351V54.6051C205.52 54.5774 205.507 54.5546 205.505 54.5285C205.502 54.491 205.492 54.4584 205.484 54.4226C205.458 54.3093 205.408 54.2031 205.337 54.1112C205.326 54.0966 205.328 54.0786 205.316 54.064L192.276 39.394C192.271 39.3891 192.265 39.3891 192.26 39.3842C192.16 39.2802 192.035 39.2048 191.896 39.1658C191.865 39.156 191.838 39.1527 191.805 39.1478C191.758 39.1397 191.714 39.1201 191.665 39.1201H168.845C167.497 39.1201 166.4 40.2171 166.4 41.5651V88.8351C166.4 90.1831 167.497 91.2801 168.845 91.2801ZM192.48 42.0786L202.891 53.7901H193.295C192.936 53.7901 192.48 53.1055 192.48 52.5676V42.0786ZM168.03 41.5651C168.03 41.349 168.116 41.1417 168.269 40.9888C168.421 40.836 168.629 40.7501 168.845 40.7501H190.85V52.5676C190.85 53.8863 191.918 55.4201 193.295 55.4201H203.89V88.8351C203.89 89.0513 203.804 89.2586 203.651 89.4114C203.498 89.5642 203.291 89.6501 203.075 89.6501H168.845C168.389 89.6501 168.03 89.2915 168.03 88.8351V41.5651Z",
    fill: "#514C9F"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M202.891 53.7902L192.48 42.0786V52.5677C192.48 53.1056 192.936 53.7902 193.295 53.7902H202.891Z",
    fill: "#514C9F"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M202.891 53.7902L192.48 42.0786V52.5677C192.48 53.1056 192.936 53.7902 193.295 53.7902H202.891Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M202.891 53.7902L192.48 42.0786V52.5677C192.48 53.1056 192.936 53.7902 193.295 53.7902H202.891Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M177.2 49.2002H172.64H173.884C174.323 49.2002 174.745 49.3736 175.056 49.6822C175.367 49.9908 175.542 50.4094 175.542 50.8459C175.542 51.2824 175.367 51.701 175.056 52.0096C174.745 52.3182 174.323 52.4916 173.884 52.4916H172.64L175.127 54.9602M172.64 50.8459H177.2",
    stroke: "#514C9F",
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M177.2 49.2002H172.64H173.884C174.323 49.2002 174.745 49.3736 175.056 49.6822C175.367 49.9908 175.542 50.4094 175.542 50.8459C175.542 51.2824 175.367 51.701 175.056 52.0096C174.745 52.3182 174.323 52.4916 173.884 52.4916H172.64L175.127 54.9602M172.64 50.8459H177.2",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M177.2 49.2002H172.64H173.884C174.323 49.2002 174.745 49.3736 175.056 49.6822C175.367 49.9908 175.542 50.4094 175.542 50.8459C175.542 51.2824 175.367 51.701 175.056 52.0096C174.745 52.3182 174.323 52.4916 173.884 52.4916H172.64L175.127 54.9602M172.64 50.8459H177.2",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M177.2 77.04H172.64H173.884C174.323 77.04 174.745 77.2134 175.056 77.5221C175.367 77.8307 175.542 78.2493 175.542 78.6858C175.542 79.1222 175.367 79.5408 175.056 79.8494C174.745 80.1581 174.323 80.3315 173.884 80.3315H172.64L175.127 82.8M172.64 78.6858H177.2",
    stroke: "#514C9F",
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M177.2 77.04H172.64H173.884C174.323 77.04 174.745 77.2134 175.056 77.5221C175.367 77.8307 175.542 78.2493 175.542 78.6858C175.542 79.1222 175.367 79.5408 175.056 79.8494C174.745 80.1581 174.323 80.3315 173.884 80.3315H172.64L175.127 82.8M172.64 78.6858H177.2",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M177.2 77.04H172.64H173.884C174.323 77.04 174.745 77.2134 175.056 77.5221C175.367 77.8307 175.542 78.2493 175.542 78.6858C175.542 79.1222 175.367 79.5408 175.056 79.8494C174.745 80.1581 174.323 80.3315 173.884 80.3315H172.64L175.127 82.8M172.64 78.6858H177.2",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M177.2 63.3604H172.64H173.884C174.323 63.3604 174.745 63.5337 175.056 63.8424C175.367 64.151 175.542 64.5696 175.542 65.0061C175.542 65.4425 175.367 65.8611 175.056 66.1698C174.745 66.4784 174.323 66.6518 173.884 66.6518H172.64L175.127 69.1204M172.64 65.0061H177.2",
    stroke: "#514C9F",
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M177.2 63.3604H172.64H173.884C174.323 63.3604 174.745 63.5337 175.056 63.8424C175.367 64.151 175.542 64.5696 175.542 65.0061C175.542 65.4425 175.367 65.8611 175.056 66.1698C174.745 66.4784 174.323 66.6518 173.884 66.6518H172.64L175.127 69.1204M172.64 65.0061H177.2",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M177.2 63.3604H172.64H173.884C174.323 63.3604 174.745 63.5337 175.056 63.8424C175.367 64.151 175.542 64.5696 175.542 65.0061C175.542 65.4425 175.367 65.8611 175.056 66.1698C174.745 66.4784 174.323 66.6518 173.884 66.6518H172.64L175.127 69.1204M172.64 65.0061H177.2",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M180.22 54.7172C180.033 54.9047 180.033 55.2086 180.22 55.3961C180.408 55.5835 180.712 55.5835 180.899 55.3961L180.22 54.7172ZM186.513 49.5838C186.513 49.3187 186.298 49.1038 186.033 49.1038H181.713C181.448 49.1038 181.233 49.3187 181.233 49.5838C181.233 49.8489 181.448 50.0638 181.713 50.0638H185.553V53.9038C185.553 54.1689 185.768 54.3838 186.033 54.3838C186.298 54.3838 186.513 54.1689 186.513 53.9038V49.5838ZM180.899 55.3961L186.372 49.9232L185.693 49.2444L180.22 54.7172L180.899 55.3961Z",
    fill: "#ECEBFF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M180.22 82.5571C180.033 82.7445 180.033 83.0484 180.22 83.2359C180.408 83.4233 180.712 83.4233 180.899 83.2359L180.22 82.5571ZM186.513 77.4236C186.513 77.1585 186.298 76.9436 186.033 76.9436H181.713C181.448 76.9436 181.233 77.1585 181.233 77.4236C181.233 77.6887 181.448 77.9036 181.713 77.9036H185.553V81.7436C185.553 82.0087 185.768 82.2236 186.033 82.2236C186.298 82.2236 186.513 82.0087 186.513 81.7436V77.4236ZM180.899 83.2359L186.372 77.7631L185.693 77.0842L180.22 82.5571L180.899 83.2359Z",
    fill: "#ECEBFF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M186.419 64.0831C186.607 63.8956 186.607 63.5917 186.419 63.4042C186.232 63.2168 185.928 63.2168 185.74 63.4042L186.419 64.0831ZM180.127 69.2165C180.127 69.4816 180.342 69.6965 180.607 69.6965H184.927C185.192 69.6965 185.407 69.4816 185.407 69.2165C185.407 68.9514 185.192 68.7365 184.927 68.7365H181.087V64.8965C181.087 64.6314 180.872 64.4165 180.607 64.4165C180.342 64.4165 180.127 64.6314 180.127 64.8965V69.2165ZM185.74 63.4042L180.268 68.8771L180.946 69.5559L186.419 64.0831L185.74 63.4042Z",
    fill: "#ECEBFF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M190.04 81.8403H200.36",
    stroke: "#514C9F",
    strokeWidth: 0.96,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M190.04 68.3999H200.36",
    stroke: "#514C9F",
    strokeWidth: 0.96,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M190.04 79.9199H200.36",
    stroke: "#514C9F",
    strokeWidth: 0.96,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M190.04 66.48H200.36",
    stroke: "#514C9F",
    strokeWidth: 0.96,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M190.04 78H200.36",
    stroke: "#514C9F",
    strokeWidth: 0.96,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M190.04 64.5601H200.36",
    stroke: "#514C9F",
    strokeWidth: 0.96,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_265_421",
    x: 0.0399902,
    y: 39.9199,
    width: 40.4,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.317647 0 0 0 0 0.298039 0 0 0 0 0.623529 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_265_421"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_265_421",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_265_421",
    x: 52.5,
    y: 2,
    width: 101,
    height: 135,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -8,
    dy: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.317647 0 0 0 0 0.298039 0 0 0 0 0.623529 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_265_421"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_265_421",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_265_421",
    x: 163.96,
    y: 39.9199,
    width: 40.4,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.317647 0 0 0 0 0.298039 0 0 0 0 0.623529 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_265_421"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_265_421",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomeDoc);
export default __webpack_public_path__ + "static/media/incomeDoc.ac57434df5a8945e631482a8c363d634.svg";
export { ForwardRef as ReactComponent };